import React, {Component} from 'react';
import {NavLink} from 'react-router-dom'
import _ from 'lodash';
import Loading from './../loading';
import InmPagination from './../widgets/inmPagination';
import {confirmAlert} from 'react-confirm-alert';

export default class UsersTable extends Component{
	render(){
		let { isFetching, list, pages, permissions } = this.props;
		let uu = _.find(permissions, (o) => o ==='Update');
		let ud = _.find(permissions, (o) => o ==='Delete');
		let table = _.map(list, (item, i) => {
			return <tr key={i}>
					<td style={{width: '10%'}}>
						<div className="actions">
							{uu && <NavLink to={`/usuarios/editar/${item.id}`}><i className="fa fa-edit" /></NavLink>}
							{ud && <button onClick={() => this._getConfirm(item.id, `${item.name} ${item.last_name} ${item.slast_name ? item.slast_name : ''}`)}><i className="fa fa-trash-o" /></button>}
						</div>
						{item.id}
					</td>
					<td><strong>{`${item.name} ${item.last_name} ${item.slast_name ? item.slast_name : ''}`}</strong></td>
					<td>{item.email}</td>
					<td><div className="tags">{_.map(item.roles,(tag, k) => <span key={k} className="tag is-dark">{tag.display ? tag.display:tag.name}</span>)}</div></td>
					<td>
						<strong className={`has-text-${item.status.style}`}>{item.status.name}</strong>
					</td>
				</tr>
		});
		
		return [
				isFetching ? <Loading key="users-loading" message="Cargando usuarios..." /> :
				<table className="inm-table" key="users-table">
					<thead>
					<tr>
						<th>ID</th>
						<th>Nombre</th>
						<th>E-mail</th>
						<th>Perfil</th>
						<th>Estatus</th>
					</tr>
					</thead>
					<tbody>
						{table}
					</tbody>
				</table>,

				(!_.isEmpty(list) && pages.total > 20) &&
				<InmPagination
					current={pages.current}
					total={pages.total}
					nextPage={this._handlePageChange}
					key="users-pages"
				/>
		]
	}

	constructor() {
		super();
		this._handlePageChange = this._handlePageChange.bind(this);
	}

	_handlePageChange(value) {
		//this.props.usersList(value);
		const { filters } = this.props;
		//console.log('?==>',pages.q);
		this.props.usersList(value,filters);
	}

	_getConfirm(id, name){
		confirmAlert({
			title: '¿Está seguro?',
			message: `¿Estás seguro/(a) de eliminar el usuario "${name}"?`,
			confirmLabel: 'Aceptar',
			cancelLabel: 'Cancelar',
			onConfirm: () => this.props.userDelete(id)
		})
	}
}



// WEBPACK FOOTER //
// ./src/elements/users/usersTable.jsx